var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZzimlogo5024 = function SvgZzimlogo5024(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#zzimlogo_50_24_svg__a)",
    d: "m25.067 3.639 2.874 2.852-1.999 1.983-2.873-2.852zM32.97 1.5l-5.03 4.99 2 1.984 5.028-4.99z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.848 9.031h-4.01l-1.567 8.802h4.01z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M44.543 9.031h-9.575c-1.972 0-2.965.791-3.317 2.71l-1.215 6.844a.49.49 0 0 1-.483.402H16.59l6.427-6.56s.51-.453.64-1.244a1.82 1.82 0 0 0-1.803-2.152H2.758l-.627 3.5h6.204l-7.183 7.04s-.314.285-.405.764A1.845 1.845 0 0 0 2.562 22.5h29.885c.797 0 1.476-.57 1.607-1.335l1.45-8.18c.078-.428.091-.44.535-.44h2.43L36.705 22.5h4.05l1.763-9.968h1.28c.575 0 .94.116 1.136.35.21.246.262.687.144 1.348l-1.463 8.27h4.05l1.475-8.31c.314-1.697.105-2.955-.627-3.81-.757-.908-2.063-1.349-3.97-1.349M6.963 19l6.335-6.456h4.689L11.392 19z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "zzimlogo_50_24_svg__a",
    x1: 23.09,
    x2: 35.043,
    y1: 4.744,
    y2: 4.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FE8AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0048FF"
  })))));
};
export default SvgZzimlogo5024;